module.exports = __webpack_public_path__ + "static/TIKTOK-257c8e351bb276a787ec012f18b77bdc.mp4";